import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import cn from 'classnames';
import { FormSpy, useField } from 'react-final-form';

import {
  getIsPlanErknmStatusConsidered,
  getIsPlanErknmStatusUnderConsideration,
} from 'APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import {
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from 'AuthPackage/MainModule/selectors/authSelectors';
import { KNM_VERIFIED_PERSON } from 'CorePackage/MainModule/routes/routes';
import { IKnmErknmFormSubject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';
import {
  getKnmFormRef,
  getKnmErknmParticipantPositionsSelectOptions,
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusRejected,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsNew,
  getKnmDataCreated,
  getKnmWatchOnlyByTestUser,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsNeedActSaveOrSign,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { IBooleanSelectOption } from 'KnmPackage/MainModule/interfaces/IBooleanSelectOption';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import {
  getOrganizationBlockId,
  INSPECTORS_BLOCK_ID,
  getInspectorBlockId,
  REMOTE_NOTE_ID,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { IKnmErknmFormObject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { ErknmInspectors } from 'KnmErknmPackage/ErknmInspectors/components/ErknmInspectors';
import { getPlanListPlanErknmStatus } from 'PlanListPackage/MainModule/selectors/planListSelectors';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IParticipantPosition } from 'APIPackage/DictionariesModule/interfaces/IParticipantPosition';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { InspectionResultActionTypeEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultActionTypeEnum';
import { InspectionResultFieldEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultFieldEnum';
import { ErknmInspectionResultMessage } from 'KnmErknmPackage/MainModule/components/ErknmInspectionResultMessageMessage';
import { IInspectionResult } from 'APIPackage/CatalogsModule/interfaces/IInspectionResult';
import { IKnmErknmFormReason } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormReason';
import { useHasFieldApproveRemark } from 'KnmErknmPackage/MainModule/common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from 'KnmErknmPackage/ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { IKnmErknmFormRescheduling } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormRescheduling';
import { createTypedUseFormError } from 'hooks/useTypedFormField';
import { IKnmErknmForm } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmForm';
import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';
import { removeSubjectErvkObjects } from 'KnmPackage/MainModule/common/removeSubjectErvkObjects';

import { ErknmSubjectItem } from './ErknmSubjectItem';
import { ErknmExperts } from './ErknmExperts';
import styles from './ErknmSubject.module.scss';
import { makeRequired } from '../../../CorePackage/MainModule/validators/isRequired';
import { CommonCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { SelectInputFieldAutoOptions } from '../../../UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { IInteractionCategorySelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IInteractionCategorySelectOption';
import { getCatalogsInteractionCategorySelectOptions } from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { ErknmFillInProcessMessage } from '../../MainModule/components/ErknmFillInProcessMessage';
import { VideoCallInfo } from './VideoCallInfo/VideoCallInfo';
import { IKnmTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { KnmTypeCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { ErknmFieldMark } from '../../MainModule/components/ErknmFieldMark';
import { checkHasErrorInCollapseBlock } from '../../../functions/checkHasErrorInCollapseBlock';

const useError = createTypedUseFormError<IKnmErknmForm>();

interface IErknmSubjectProps {
  disableFieldByCompleteStatuses: boolean;
  disableFieldByInProcessStatuses: boolean;
  disableSubjectInfo: boolean;
  formKindKnmCode: string | undefined;
  interactionCategory: IInteractionCategorySelectOption | undefined;
  isRemote: IBooleanSelectOption | undefined;
  objects: IKnmErknmFormObject[] | undefined;
  setEventInteractionCategoryOptions: Dispatch<SetStateAction<IInteractionCategorySelectOption[] | undefined>>;
  typeCode: IKnmTypeSelectOption['code'] | undefined;
  watchOnlyExtended: boolean;
  organizations: IKnmErknmFormSubject[] | undefined;
  reasonsErknm: IKnmErknmFormReason[] | undefined;
  shouldValidationForGeneratedDecision?: boolean;
  rescheduling?: IKnmErknmFormRescheduling[] | null | undefined;
}

interface IErknmSubjectStoreProps {
  allEventInteractionCategoryOptions: IInteractionCategorySelectOption[] | undefined;
  created: string | null | undefined;
  formRef: IKnmFormRef;
  isEditableInStatusCommentsExist: boolean;
  isKnmStatusApproving: boolean;
  isKnmStatusCommentsExist: boolean;
  isKnmStatusCompleted: boolean;
  isKnmStatusFillInProcess: boolean;
  isKnmStatusReadyForApprove: boolean;
  isKnmStatusRejected: boolean;
  isKnmStatusTypeWaitingCarryOut: boolean;
  isKnmStatusTypeCarriedOut: boolean;
  isNewKnm: boolean;
  isProsecutorOrSuperProsecutor: boolean;
  isSupervisor: boolean;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
  positionsSelectOptions: IDictionarySelectOption<IParticipantPosition>[] | undefined;
  settings: IAdminSetting[] | undefined;
  isWatchOnlyByTestUser: boolean;
  isNeedActSaveOrSign?: boolean;
}

const ErknmSubjectWithoutStore = ({
  disableFieldByCompleteStatuses,
  disableFieldByInProcessStatuses,
  disableSubjectInfo,
  formKindKnmCode,
  interactionCategory,
  isRemote,
  objects,
  setEventInteractionCategoryOptions,
  typeCode,
  watchOnlyExtended,
  created,
  allEventInteractionCategoryOptions,
  formRef,
  isEditableInStatusCommentsExist,
  isKnmStatusApproving,
  isKnmStatusCommentsExist,
  isKnmStatusCompleted,
  isKnmStatusFillInProcess,
  isKnmStatusReadyForApprove,
  isKnmStatusRejected,
  isKnmStatusTypeWaitingCarryOut,
  isKnmStatusTypeCarriedOut,
  isNewKnm,
  isProsecutorOrSuperProsecutor,
  isSupervisor,
  knmPlanStatus,
  positionsSelectOptions,
  settings,
  isWatchOnlyByTestUser,
  organizations,
  isNeedActSaveOrSign = false,
  reasonsErknm,
  shouldValidationForGeneratedDecision,
  rescheduling,
}: IErknmSubjectProps & IErknmSubjectStoreProps) => {
  const [knmCollapseOpened, setKnmCollapseOpened] = useState<{ [key: string]: boolean }>({});
  const isEnablePaperlessDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );
  const isSubjectDeleted = useField<boolean>('isSubjectDeleted').input.value ?? false;

  const { error: organizationsFieldError } = useError('organizations');
  const toDisplayOrganizationsFieldError =
    typeof organizationsFieldError === 'string' ? organizationsFieldError : undefined;

  const isMultiFields = formKindKnmCode === KnmKindCodesEnum.RO;
  const isMultiFieldsByVisibleForRepeatCheck = useRef(
    formKindKnmCode !== KnmKindCodesEnum.RO && isEnablePaperlessDocument && (organizations?.length || 0) > 1,
  );

  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;
  const isKnmPlanStatusUnderConsideration: boolean = getIsPlanErknmStatusUnderConsideration(knmPlanStatus);
  const isKnmPlanStatusConsidered: boolean = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isKnmKindRemarkExist = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.KIND_KNM);
  const isImpossibilityOfPrevious = reasonsErknm?.[0]?.type?.name === KnmReasonTypeNameEnum.IMPOSSIBILITY_OF_PREVIOUS;

  const shouldValidateKnmKindRemark = isKnmPlanStatusConsidered && isKnmKindRemarkExist;

  const isRequiredSubject = useRef(formKindKnmCode !== KnmKindCodesEnum.RO || isImpossibilityOfPrevious);
  const isTypeCodeVP = typeCode === KnmTypeCodesEnum.VP;
  const isTypeCodePP = typeCode === KnmTypeCodesEnum.PP;
  const isTypeCodePP248P294 = typeCode === KnmTypeCodesEnum.PP248P294;
  const isRequiredWithKnmKindRemarkCheck = useRef(shouldValidateKnmKindRemark && !organizations?.length);

  const isDisableFieldsInPlanUnderConsideration =
    (isKnmStatusApproving || isKnmStatusCommentsExist || isKnmStatusTypeWaitingCarryOut || isKnmStatusRejected) &&
    isKnmPlanStatusUnderConsideration;

  const isDisableFieldsInPlanUnderConsiderationForProsecutor =
    isProsecutorOrSuperProsecutor && isDisableFieldsInPlanUnderConsideration;
  const isDisableDeleteApprovingFields =
    !isKnmStatusFillInProcess &&
    !isKnmStatusReadyForApprove &&
    !isKnmStatusTypeCarriedOut &&
    !isKnmStatusTypeWaitingCarryOut &&
    !isEditableInStatusCommentsExist;

  const isActiveField =
    formKindKnmCode === KnmKindCodesEnum.MZ ||
    formKindKnmCode === KnmKindCodesEnum.KZ ||
    formKindKnmCode === KnmKindCodesEnum.IV ||
    formKindKnmCode === KnmKindCodesEnum.VP;

  const isLaterThan4154 = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_4_1_54_STARTS_FROM,
  );

  const isEachErvkIdNotEmpty = objects === undefined || objects?.every(object => object.ervkId !== undefined);

  const isAddButtonDisabled =
    watchOnlyExtended ||
    disableFieldByCompleteStatuses ||
    disableFieldByInProcessStatuses ||
    disableSubjectInfo ||
    isImpossibilityOfPrevious;

  const isNotAddButtonVisible = isLaterThan4154 && isEachErvkIdNotEmpty && isTypeCodeVP;

  const isShowInteractionCategory = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_4_1_55_STARTS_FROM,
  );

  useEffect(() => {
    isMultiFieldsByVisibleForRepeatCheck.current =
      formKindKnmCode !== KnmKindCodesEnum.RO && isEnablePaperlessDocument && (organizations?.length || 0) > 1;
  }, [formKindKnmCode, isEnablePaperlessDocument, organizations]);

  useEffect(() => {
    isRequiredWithKnmKindRemarkCheck.current =
      (shouldValidationForGeneratedDecision || shouldValidateKnmKindRemark || isImpossibilityOfPrevious) &&
      !organizations?.length &&
      formKindKnmCode !== KnmKindCodesEnum.RO;
  }, [isKnmPlanStatusConsidered, isKnmKindRemarkExist, organizations]);

  const isInteractionCategoryActive =
    !isWatchOnlyByTestUser &&
    isSupervisor &&
    (isNewKnm ||
      isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isEditableInStatusCommentsExist ||
      (isKnmStatusRejected && isKnmPlanStatusConsidered) ||
      shouldValidateKnmKindRemark);

  const addSubjectItem = useCallback(() => {
    if (!watchOnlyExtended && push) {
      const addingSubjectItem: IKnmErknmFormSubject = {
        inn: undefined,
        ogrn: undefined,
        position: undefined,
        okveds: undefined,
        addressFns: undefined,
        organizationName: undefined,
        firstOrganizationName: undefined,
        mspCode: undefined,
        mspRegistryDate: undefined,
        checkSubjectResult: null,
        dateCreate: undefined,
        isAutocomplete: undefined,
        isFiz: undefined,
        guid: undefined,
        isDocumentOrganization: false,
        listId: uuidv4(),
        isNew: true,
        nkoForeignAgentsRegistryNumber: undefined,
        nkoForeignAgentsRegistryInclusionDate: undefined,
        nkoForeignAgentsRegistryExclusionDate: undefined,
        isNko: undefined,
        subjectType: undefined,
        kpp: undefined,
        smevRequestStatus: undefined,
        rafpNza: undefined,
        isForeignSubjectAgencyNotRegistredInRf: undefined,
        country: undefined,
        isSonko: undefined,
        locationAddress: undefined,
        workAddress: undefined,
        factualAddress: undefined,
        snils: undefined,
        document: undefined,
        epguNotifications: undefined,
        ervkId: undefined,
        isPresentInItRegistry: undefined,
        itAccreditationResponse: undefined,
        smevItAccreditationRequestStatus: undefined,
        inspectionResults: undefined,
        locationregion: undefined,
        locationnotInFIAS: undefined,
        locationmanualAddress: undefined,
        locationfiasRegion: undefined,
      };

      const organizationsArray = formRef?.current.getFieldState('organizations')?.value;

      if (organizationsArray && organizationsArray.length !== 0) {
        if (!isMultiFields) {
          remove('organizations', 0);
        }
      }

      push('organizations', addingSubjectItem);
    }
  }, [formRef, push, remove, watchOnlyExtended, isMultiFields]);

  const makeRemoveErknmSubjectItemHandler = (index: number, ervkId: string | undefined) => () => {
    // Раньше удаление КЛ было под !watchOnlyExtended, а каскад по ОБК - нет,
    // и в режиме только для чтения клик убирал бы ОБК, оставляя КЛ.
    if (watchOnlyExtended || !remove) {
      return;
    }

    remove('organizations', index) && formRef?.current?.change('isSubjectDeleted', true);

    removeSubjectErvkObjects({ formRef, ervkId, objectsFieldName: 'objectsErknm' });
  };

  useEffect(() => {
    isRequiredSubject.current =
      formKindKnmCode !== KnmKindCodesEnum.RO ||
      (formKindKnmCode === KnmKindCodesEnum.RO && (!objects || objects?.length === 0));
  }, [formKindKnmCode, objects]);

  const handleInteractionCategoryChange = useCallback(
    (selectedCategory: IInteractionCategorySelectOption) => {
      if (!selectedCategory) {
        setEventInteractionCategoryOptions(undefined);
      } else if (selectedCategory.value === 1 && isActiveField) {
        setEventInteractionCategoryOptions(allEventInteractionCategoryOptions?.filter(x => x.id === 1));
      } else if (selectedCategory.value === 3 && isActiveField) {
        setEventInteractionCategoryOptions(allEventInteractionCategoryOptions?.filter(x => x.id === 3));
      } else {
        setEventInteractionCategoryOptions(allEventInteractionCategoryOptions);
      }

      formRef.current.change(`videoCallInfo`);

      const events = formRef?.current.getFieldState('eventsErknm')?.value;

      if (events) {
        events.forEach((item, index) => {
          formRef.current.change(`eventsErknm[${index}].interactionCategory` as keyof IKnmForm);
        });
      }
    },
    [formRef, allEventInteractionCategoryOptions, setEventInteractionCategoryOptions],
  );

  const addButton = () => {
    if (isNotAddButtonVisible || isTypeCodePP || isTypeCodePP248P294) {
      return;
    }

    if (isMultiFields) {
      return (
        <span className="shared-no-wrap-text">
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            disabled={isAddButtonDisabled}
            onClick={addSubjectItem}
          />
        </span>
      );
    }

    const organizationsArray = formRef?.current.getFieldState('organizations')?.value;

    return (
      (!organizationsArray || organizationsArray.length === 0) && (
        <span className="shared-no-wrap-text">
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            disabled={isAddButtonDisabled}
            onClick={addSubjectItem}
          />
        </span>
      )
    );
  };

  const isShow22 = isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_4_1_22_STARTS_FROM);

  const generateCollapseName = useCallback((inspectionResult: IInspectionResult | undefined) => {
    if (inspectionResult) {
      return <ErknmInspectionResultMessage inspectionResult={inspectionResult} />;
    }

    return undefined;
  }, []);

  const validate = (orgs: IKnmErknmFormSubject[] | undefined) => {
    if (isRequiredWithKnmKindRemarkCheck.current) {
      return 'Поле не может быть пустым';
    }

    if (isMultiFieldsByVisibleForRepeatCheck.current) {
      return 'Может быть указано только одно контролируемое лицо';
    }

    if (isRequiredSubject.current) {
      return makeRequired('Поле не может быть пустым')(orgs);
    }

    return '';
  };

  const canCloseAccordion = useCallback(
    (isConnectedToErvkObject: boolean) => {
      // Лишние КЛ в безбумажном паспорте нужно дать удалить, но правило «ЕРВК-КЛ только через ОБК»
      // действует и здесь.
      if (isMultiFieldsByVisibleForRepeatCheck.current) {
        return !isConnectedToErvkObject;
      }

      // При «Невозможности проведения...» КЛ приходит из ссылки, но предзаполнение удалению
      // не мешает (4.1.30). Запрещает только связь с объектом из ЕРВК, такой КЛ удаляется через ОБК.
      if (isImpossibilityOfPrevious) {
        return !isConnectedToErvkObject;
      }

      return !(
        watchOnlyExtended ||
        disableFieldByCompleteStatuses ||
        disableFieldByInProcessStatuses ||
        disableSubjectInfo ||
        isConnectedToErvkObject
      );
    },
    [
      isMultiFieldsByVisibleForRepeatCheck.current,
      watchOnlyExtended,
      disableFieldByCompleteStatuses,
      disableFieldByInProcessStatuses,
      disableSubjectInfo,
      isImpossibilityOfPrevious,
    ],
  );

  return (
    <>
      <FieldBlock
        label={
          <>
            {formKindKnmCode === KnmKindCodesEnum.IV
              ? 'Сведения о контролируемом лице и (или) владельце/пользователе производственного объекта'
              : 'Сведения о контролируемом лице'}
            {(formKindKnmCode !== KnmKindCodesEnum.RO || !isKnmStatusFillInProcess) && (
              <ErknmFieldMark fieldName="organizations" />
            )}
          </>
        }
        id={KNM_VERIFIED_PERSON}
        button={addButton()}
      >
        {!!toDisplayOrganizationsFieldError && (
          <p className="shared-input-error shared-row__small-margin">{toDisplayOrganizationsFieldError}</p>
        )}

        <FieldArray name="organizations" key={isRequiredSubject.current ? 0 : 1} validate={validate}>
          {({ fields }: FieldArrayRenderProps<IKnmErknmFormSubject, HTMLElement>) => {
            if (!fields || !fields.length || fields.length === 0) {
              return null;
            }

            return (
              <>
                <FormSpy subscription={{ errors: true, touched: true }}>
                  {props => {
                    if (props.errors?.organizations) {
                      const fieldError = props.errors?.organizations['FINAL_FORM/array-error'];

                      if (fieldError && typeof fieldError === 'string') {
                        return <p className="shared-input-error">{fieldError}</p>;
                      }
                    }

                    return null;
                  }}
                </FormSpy>
                {fields.map((name, index) => {
                  const fieldValue: IKnmErknmFormSubject = fields.value?.[index];
                  const id = getOrganizationBlockId(fieldValue.listId);
                  const isNewObject = fieldValue.isNew;

                  const hasError = checkHasErrorInCollapseBlock(formRef, name);

                  const isConnectedToErvkObject =
                    !!fieldValue.ervkId &&
                    !!formRef?.current
                      .getFieldState('objectsErknm')
                      ?.value?.flatMap(object => object.organizationErvkId)
                      ?.find(x => x === fieldValue.ervkId);

                  const renderItem = (isCollapsing: boolean) => (
                    <ErknmSubjectItem
                      {...(!isMultiFields ? { key: id } : {})}
                      id={id}
                      name={name}
                      watchOnlyExtended={
                        watchOnlyExtended ||
                        isDisableFieldsInPlanUnderConsideration ||
                        disableFieldByCompleteStatuses ||
                        disableFieldByInProcessStatuses ||
                        disableSubjectInfo
                      }
                      disableFieldByCompleteStatuses={disableFieldByCompleteStatuses}
                      disableFieldByInProcessStatuses={disableFieldByInProcessStatuses}
                      isConnectedToErvkObject={isConnectedToErvkObject}
                      isCollapsing={isCollapsing}
                      okveds={fieldValue.okveds}
                      inn={fieldValue.inn}
                      ogrn={fieldValue.ogrn}
                      firstOrganizationName={fieldValue.firstOrganizationName}
                      inspectionResults={fieldValue.inspectionResults}
                      checkSubjectResult={fieldValue.checkSubjectResult}
                      isAutocomplete={fieldValue.isAutocomplete}
                      isMultiFields={isMultiFields}
                      mspCode={fieldValue.mspCode}
                      mspRegistryDate={fieldValue.mspRegistryDate}
                      isNew={!!fieldValue.isNew}
                      subjectType={fieldValue.subjectType}
                      kpp={fieldValue.kpp}
                      smevRequestStatus={fieldValue.smevRequestStatus}
                      rafpNza={fieldValue.rafpNza}
                      isSonko={fieldValue.isSonko}
                      snils={fieldValue.snils}
                      ervkId={fieldValue.ervkId}
                      isPresentInItRegistry={fieldValue.isPresentInItRegistry}
                      itAccreditationResponse={fieldValue.itAccreditationResponse}
                      smevItAccreditationRequestStatus={fieldValue.smevItAccreditationRequestStatus}
                      disabledRemoveObject={!canCloseAccordion(isConnectedToErvkObject)}
                      isFilledFromLink={fieldValue.isFilledFromLink === true}
                    />
                  );

                  if (!fieldValue.isNew && fieldValue.isEmpty) {
                    return null;
                  }

                  const inspectionResultAvailable = fieldValue.inspectionResults?.find(
                    i =>
                      i.inspectedField === InspectionResultFieldEnum.ORGANIZATION_ERVK_NAME ||
                      i.inspectedField === InspectionResultFieldEnum.ORGANIZATION_FNS_NOT_FOUND ||
                      i.inspectedField === InspectionResultFieldEnum.ORGANIZATION_ERVK_ADDRESS ||
                      i.inspectedField === InspectionResultFieldEnum.RAFP_REGISTRY,
                  );

                  if (isMultiFields || isMultiFieldsByVisibleForRepeatCheck.current) {
                    return (
                      <KnmCollapse
                        id={id}
                        theme="fields"
                        title={`Контролируемое лицо №${index + 1}`}
                        isNew={isNewObject}
                        opened={isNewObject}
                        subtitle={generateCollapseName(inspectionResultAvailable)}
                        headerClassName={cn([
                          {
                            [styles.BorderYellow]:
                              inspectionResultAvailable &&
                              inspectionResultAvailable.resultActionType ===
                                InspectionResultActionTypeEnum.LIGHT_YELLOW,
                            [styles.BorderRed]:
                              inspectionResultAvailable &&
                              inspectionResultAvailable.resultActionType === InspectionResultActionTypeEnum.LIGHT_RED,
                          },
                        ])}
                        onClose={
                          canCloseAccordion(isConnectedToErvkObject) && !watchOnlyExtended
                            ? makeRemoveErknmSubjectItemHandler(index, fieldValue.ervkId)
                            : undefined
                        }
                        key={name}
                        changeOpenedCallback={e =>
                          setKnmCollapseOpened(state => ({
                            ...state,
                            [name]: e,
                          }))
                        }
                        error={hasError && knmCollapseOpened[name]}
                      >
                        {renderItem(true)}
                      </KnmCollapse>
                    );
                  }

                  return renderItem(false);
                })}
              </>
            );
          }}
        </FieldArray>

        {isImpossibilityOfPrevious && isSubjectDeleted && (
          <div className={styles.Yellow}>
            Для добавления сведений в раздел необходимо удалить и повторно добавить ссылку на паспорт
          </div>
        )}
        {formKindKnmCode === KnmKindCodesEnum.DP && (
          <>
            <Row>
              <FieldBlock
                label="Дата направления требования представить необходимые для рассмотрения в ходе документарной проверки
                  документы"
              >
                <DatePickerField
                  className={styles.DocumentRequestDateField}
                  id="documentRequestDate"
                  name="documentRequestDate"
                  disabled={watchOnlyExtended || isDisableFieldsInPlanUnderConsiderationForProsecutor}
                />
              </FieldBlock>
            </Row>

            <Row>
              <FieldBlock
                label="Дата получения документов во исполнение требования представить необходимые для рассмотрения в ходе
                документарной проверки документы"
              >
                <DatePickerField
                  className={styles.DocumentResponseDateField}
                  id="documentResponseDate"
                  name="documentResponseDate"
                  disabled={watchOnlyExtended || isDisableFieldsInPlanUnderConsiderationForProsecutor}
                />
              </FieldBlock>
            </Row>
          </>
        )}

        <ErknmInspectors
          watchOnly={
            watchOnlyExtended ||
            isDisableFieldsInPlanUnderConsiderationForProsecutor ||
            isKnmStatusApproving ||
            isKnmStatusCompleted ||
            isNeedActSaveOrSign
          }
          name="inspectorsErknm"
          title={
            <>
              Сведения о должностных лицах, участвующих в КНМ
              <ErknmFieldMark fieldName="inspectorsErknm" />
            </>
          }
          positionsSelectOptions={positionsSelectOptions}
          blockId={INSPECTORS_BLOCK_ID}
          isDisableDelete={isDisableDeleteApprovingFields}
          getItemBlockId={getInspectorBlockId}
        />

        <ErknmExperts isWatchOnly={isNeedActSaveOrSign} />

        {isActiveField && (
          <Row>
            <FieldBlock
              label={
                <>
                  Сведения об использовании в рамках КНМ средств дистанционного взаимодействия с контролируемыми лицами
                  <ErknmFieldMark sectionName="interactionCategorySection" />
                </>
              }
              fillInProcess={isShowInteractionCategory && <ErknmFillInProcessMessage name="interactionCategory" />}
            >
              {isShowInteractionCategory && (
                <SelectInputFieldAutoOptions
                  className={styles.InteractionCategorySelect}
                  id="interactionCategory"
                  name="interactionCategory"
                  isClearable={true}
                  size="large"
                  optionName={CommonCatalogsNamesEnum.INTERACTION_CATEGORIES}
                  placeholder={
                    <>
                      Выберите категорию взаимодействия
                      <ErknmFieldMark fieldName="interactionCategory" />
                    </>
                  }
                  disabled={!isInteractionCategoryActive}
                  onChange={handleInteractionCategoryChange}
                />
              )}
              {!isShowInteractionCategory && (
                <SelectInputField
                  className={styles.RemoteStatusSelect}
                  name="isRemote"
                  options={booleanSelectOptions}
                  isClearable={false}
                  disabled={watchOnlyExtended || isDisableFieldsInPlanUnderConsiderationForProsecutor}
                  size="medium"
                />
              )}
            </FieldBlock>
          </Row>
        )}

        {isShow22 && interactionCategory && interactionCategory.id !== 3 && (
          <VideoCallInfo isRequiredSubject={isRequiredSubject.current} rescheduling={rescheduling} />
        )}

        {!isShowInteractionCategory && isRemote?.value && (
          <Row>
            <TextInputField
              className={styles.ErknmSubjectField}
              id={REMOTE_NOTE_ID}
              name="remoteNote"
              placeholder="Введите сведения"
              disabled={watchOnlyExtended || isDisableFieldsInPlanUnderConsiderationForProsecutor}
              validate={makeRequired('Поле не может быть пустым')}
            />
          </Row>
        )}
      </FieldBlock>
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  allEventInteractionCategoryOptions: getCatalogsInteractionCategorySelectOptions(state),
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
  isEditableInStatusCommentsExist: getKnmIsEditableInStatusCommentsExist(state),
  isKnmStatusApproving: getKnmIsErknmStatusApproving(state),
  isKnmStatusCommentsExist: getKnmIsErknmStatusCommentsExist(state),
  isKnmStatusCompleted: getKnmIsErknmStatusTypeCompleted(state),
  isKnmStatusFillInProcess: getKnmIsErknmStatusFillInProcess(state),
  isKnmStatusTypeCarriedOut: getKnmIsErknmStatusTypeCarriedOut(state),
  isKnmStatusReadyForApprove: getKnmIsErknmStatusReadyForApprove(state),
  isKnmStatusRejected: getKnmIsErknmStatusRejected(state),
  isKnmStatusTypeWaitingCarryOut: getKnmIsErknmStatusTypeWaitingCarryOut(state),
  isNewKnm: getKnmIsNew(state),
  isProsecutorOrSuperProsecutor: getUserRoleIsProsecutorOrSuperProsecutor(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  positionsSelectOptions: getKnmErknmParticipantPositionsSelectOptions(state),
  settings: getAdminFetchSettings(state),
  isWatchOnlyByTestUser: getKnmWatchOnlyByTestUser(state),
  isNeedActSaveOrSign: getKnmIsNeedActSaveOrSign(state),
});

export const ErknmSubject = connect(mapStateToProps)(ErknmSubjectWithoutStore);
